<div style="background-image: url('assets/img/bg/pattern.jpg')">
<app-header-two></app-header-two>
<!-- Banner Start -->
<div class="banner banner-2">
    <div class="banner-slider-2">
      <div class="banner-item">
        <div class="banner-bg bg-cover" style="background-image: url('assets/img/banner/1.jpg')"></div>
        <div class="banner-inner">
          <div class="banner-text">
            <h1 class="title">Italian Pizza Never Got Any Better</h1>
            <h4>It is the cheese that lures us into eating</h4>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
            </p>
          </div>
          <a href="#" class="btn-custom primary">View Menu</a>
        </div>
        <img src="assets/img/veg/12.png" alt="bg">
      </div>
      <div class="banner-item">
        <div class="banner-bg bg-cover" style="background-image: url('assets/img/banner/2.jpg')"></div>
        <div class="banner-inner">
          <div class="banner-text">
            <h1 class="title">Celebrating 100 Years of Cheesy Pizza</h1>
            <h4>Join our grand opening tonight for free pizza</h4>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
            </p>
          </div>
          <a href="#" class="btn-custom primary">Join Now</a>
        </div>
        <img src="assets/img/veg/12.png" alt="bg">
      </div>
    </div>
  </div>
  <!-- Banner End -->

  <!-- Icons Start -->
  <div class="section">
    <div class="container">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">How We Do It</h5>
        <h2 class="title">We Deliver Your Food In 4 Steps</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>

      <div class="row infographics-2">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-online-booking"></i>
            <h4>Order</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-calories"></i>
            <h4>Cook</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-delivery-man"></i>
            <h4>Deliver</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-food-tray"></i>
            <h4>Enjoy</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
      </div>

      <div class="section-btn">
        <a routerLink='/menu-v1' class="btn-custom">Order Online</a>
      </div>

    </div>
  </div>
  <!-- Icons End -->

  <!-- Categories Start -->
  <div class="section pt-0 category-section">
    <div class="container">

      <!-- Arrow -->
      <i class="slider-prev fas fa-arrow-left slick-arrow"></i>

      <div class="category-slider">
        <div class="ct-category category-2">
          <div class="ct-category-desc">
            <h5 class="custom-primary">Pizza</h5>
            <h3>Crazy Pizza Offers</h3>
            <p>It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old</p>
            <a routerLink='/menu-v1' class="btn-custom">Order Now</a>
          </div>
          <img src="assets/img/prods/3.png" alt="cat">
        </div>

        <div class="ct-category category-2">
          <div class="ct-category-desc">
            <h5 class="custom-primary">Desserts</h5>
            <h3>Satisfy Your Sweet Tooth</h3>
            <p>It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old</p>
            <a routerLink='/menu-v1' class="btn-custom">Order Now</a>
          </div>
          <img src="assets/img/prods/8.png" alt="cat">
        </div>

        <div class="ct-category category-2">
          <div class="ct-category-desc">
            <h5 class="custom-primary">Sides</h5>
            <h3>Wraps You Can't Resist</h3>
            <p>It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old</p>
            <a routerLink='/menu-v1' class="btn-custom">Order Now</a>
          </div>
          <img src="assets/img/prods/9.png" alt="cat">
        </div>

        <div class="ct-category category-2">
          <div class="ct-category-desc">
            <h5 class="custom-primary">Beverages</h5>
            <h3>Juicy Sensation</h3>
            <p>It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old</p>
            <a routerLink='/menu-v1' class="btn-custom">Order Now</a>
          </div>
          <img src="assets/img/prods/10.png" alt="cat">
        </div>
      </div>

      <!-- Arrow -->
      <i class="slider-next fas fa-arrow-right slick-arrow"></i>

    </div>
  </div>
  <!-- Categories End -->

  <!-- Products Start -->
  <div class="section pt-0 products-section">
    <div class="container">

      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Trending</h5>
        <h2 class="title">Our Customers' Top Picks</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
        </p>
      </div>

      <div class="product-slider">

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/5.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Pepperoni</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">12.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/2.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Four Cheese</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">13.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/3.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Vegetarian</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">9.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="product">
          <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/4.png" alt="menu item" /> </a>
          <div class="product-body">
            <div class="product-desc">
              <h4> <a routerLink='/menu-item-v1'>Barbeque Chicken</a> </h4>
              <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              <p class="product-price">11.99$</p>
              <div class="favorite">
                <i class="far fa-heart"></i>
              </div>
            </div>
            <div class="product-controls">
              <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              <a href="#" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
            </div>
          </div>
        </div>
        <!-- Product End -->

      </div>

      <div class="ct-arrows centered-arrows">
        <i class="slider-prev fas fa-arrow-left slick-arrow"></i>
        <i class="slider-next fas fa-arrow-right slick-arrow"></i>
      </div>

    </div>
  </div>
  <!-- Products End -->

  <!-- Offer start -->
  <div class="section light-bg">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-lg-6 mb-lg-30">
          <img src="assets/img/misc/cta2.png" alt="img">
        </div>
        <div class="col-lg-6">
          <div class="section-title-wrap mr-lg-30">
            <h5 class="custom-primary">Great Offer</h5>
            <h2 class="title">Buy 1 Get 1 Free</h2>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <p class="subtitle">
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
            </p>
            <a routerLink='/menu-item-v1' class="btn-custom">Order Now</a>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Offer End -->

  <!-- Testimonials Start -->
  <section class="section testimonials">
    <div class="container">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Our Backbone</h5>
        <h2 class="title">Customer Testimonials</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>

      <div class="ct-testimonials-slider">

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/1.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>John Doe</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/2.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>Heather Madlin</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/3.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>Tina Flinston</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

        <!-- Testimonial item start -->
        <div class="ct-testimonial-slider-item">
          <div class="ct-testimonial-item">
            <div class="ct-testimonial-thumb">
              <img src="assets/img/people/4.jpg" alt="person">
            </div>
            <div class="ct-testimonial-content">
              <i class="flaticon-left-quote"></i>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <h5>Justine Donawick</h5>
              <span>Food Specialist</span>
            </div>
          </div>
        </div>
        <!-- Testimonial item end -->

      </div>

      <div class="ct-arrows centered-arrows with-margin">
        <i class="fas fa-arrow-left slider-prev"></i>
        <i class="fas fa-arrow-right slider-next"></i>
      </div>

    </div>
  </section>
  <!-- Testimonials End -->

  <!-- Newsletter start -->
  <section class="section bg-center bg-cover dark-overlay" style="background-image:url('assets/img/bg/1.jpg')">
    <div class="container">

      <div class="ct-newsletter">

        <div class="section-title-wrap section-header">
          <h2 class="title">Join Our Newsletter</h2>
          <p class="subtitle">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
          </p>
        </div>

        <form method="post">
          <input type="email" class="form-control" placeholder="Enter your email address" value="">
          <button type="submit" class="btn-custom primary" name="button"> Submit <i class="far fa-paper-plane"></i> </button>
        </form>

      </div>

    </div>
  </section>
  <!-- Newsletter End -->
<app-footer-two></app-footer-two>
</div>